import { useQuery } from "react-query";
import Select from "react-select"
import { t } from "i18next";


import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getDepartments } from "../../../../../MyApi/sb/departments";
import { getBranches } from "../../../../../MyApi/sb/branches";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";






const AddDesignations = ({
  branchId,setBranchId,companyId ,setCompanyId, setDesignationName, setSelectedOption, selectedOption, sb_department_id, setDepartmentSbId, designationName, setDescription ,description, setActive ,active
  
}) => {
  const page =0
const compaineQuery = useQuery(["getCompany",page] , ()=>getCompanies(page))
const branchesQuery = useQuery(["getBranches",page ,companyId] , ()=>getBranches(page ,companyId),{
  enabled:!!companyId
})
const departmentsQuery = useQuery(["getDepartments",page, branchId ],  ()=>getDepartments(page ,branchId),{
  enabled:!!branchId
} )

 const departments =departmentsQuery.data?.data || []
 const branches =branchesQuery.data?.data || []
 const companies = compaineQuery.data?.data  || []

  const DescriptionIcon = icons.description
  const LevelIcon = icons.levels
  const Earth = icons.Earth;
  const Company = icons.company
  const AbcIcon = icons.abc
  const handleNameChange = (e) => {
    setDesignationName(e.target.value);
  };
  const handleSbDepartmentIdChange = (selectedDepartment) => {
    const departmentId = selectedDepartment ? selectedDepartment.id :0
    setDepartmentSbId(departmentId);
  
  }; 
  const handleBranchChange =(selectedBranch)=>{
    const branchId = selectedBranch ? selectedBranch.id :0
    setBranchId(branchId)
  }
  const handleComapnyIdChange =(selectedCompany)=>{
    const companyId = selectedCompany ?selectedCompany.id :0
    setCompanyId(companyId)
  }
  const handleDescChange =(e)=>{
  setDescription(e.target.value)
  }

  const handleActiveChange = (e)=>{
    const isChecked = e.target.checked
   setActive(isChecked ? 1:0)
  }

 

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Name")} </label>
          <div className={classes.iconInput}>
            <AbcIcon />
          </div>
          <input
            type="text"
            placeholder="ادخل الاسم "
            onChange={handleNameChange}
            value={designationName}
            className={classes.inputCustom}
          /> 
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">{t("Description")} </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea  
            type="textarea"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          > </textarea> 
        </div>

        {!compaineQuery.data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Company")}</label>
         
          <Select
            type="text"
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            options={companies}
            placeholder="اختار الشركة  "
            onChange={handleComapnyIdChange}
            isClearable={true}
          />
          
        </div> }
        
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Branch")}</label>
      
          {!branchesQuery.data ? <div>يجب اختيار شركة </div> :   <Select
            type="text"
            options={branches}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            placeholder="اختار الفرع  "
            onChange={handleBranchChange}
            isClearable={true}
         /> }
        
        </div>
          
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Department")}</label>
          {!departmentsQuery.data ? <div>يجب اختيار فرع </div> :   <Select
            type="text"
            options={departments}
            getOptionValue={(e)=>e.id} 
            getOptionLabel={(e)=>e.name}
            placeholder="اختار القسم  "
            onChange={handleSbDepartmentIdChange}
            isClearable={true}
         />}
        
        </div> 
       
    
    
   
        
          <div className={classes.formCol}> 
           <label htmlFor="" className={active ? `${classes.active}` : `${classes.disActive}`}> {active==1 ?" نشط":"غير نشط"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handleActiveChange} checked={active}/>
             <span class="slider round"></span>
         </label>   
        </div>
   
      
     
      </div>
    </div>
  );
};

export default AddDesignations;
